import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Copy, Gift, UserPlus, Coins } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { useReferral } from '@/hooks/useReferral';

export function ReferralCard() {
    const { toast } = useToast();
    const { stats, copyLink } = useReferral();

    const handleCopyLink = () => {
        copyLink();
        toast({
            title: 'Link copiado!',
            description: 'Compartilhe com seus amigos e ganhe créditos',
        });
    };

    return (
        <Card className="border-primary/20 bg-gradient-to-br from-card to-primary/5">
            <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2 text-lg">
                    <UserPlus className="h-5 w-5 text-primary" />
                    Indique Amigos
                </CardTitle>
                <CardDescription>
                    Ganhe <strong className="text-primary">10 créditos</strong> quando seus indicados fizerem a primeira compra!
                </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
                {/* Link de Indicação */}
                <div className="flex gap-2">
                    <Input
                        value={stats.referralLink}
                        readOnly
                        className="font-mono text-sm"
                    />
                    <Button onClick={handleCopyLink} size="sm" className="shrink-0">
                        <Copy className="h-4 w-4 mr-2" />
                        Copiar
                    </Button>
                </div>

                {/* Stats compactas */}
                <div className="grid grid-cols-3 gap-2 text-center">
                    <div className="p-2 bg-secondary/50 rounded-lg">
                        <div className="text-lg font-bold">{stats.totalReferrals}</div>
                        <div className="text-xs text-muted-foreground">Cadastros</div>
                    </div>
                    <div className="p-2 bg-secondary/50 rounded-lg">
                        <div className="text-lg font-bold">{stats.completedReferrals}</div>
                        <div className="text-xs text-muted-foreground">Compraram</div>
                    </div>
                    <div className="p-2 bg-primary/10 rounded-lg">
                        <div className="text-lg font-bold text-primary flex items-center justify-center gap-1">
                            <Coins className="h-4 w-4" />
                            {stats.totalCreditsEarned}
                        </div>
                        <div className="text-xs text-muted-foreground">Créditos</div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
